export const DATA_CY_GLOSSARY_PREVIEW = 'glossary-preview';
